import { Stack, Typography } from "@mui/material"
import React from "react"

type ItemInfoPrps = {
  title: string
  value: string | React.ReactNode
}
const ItemInfo = ({ title, value }: ItemInfoPrps) => {
  return (
    <Stack gap={0.5}>
      <Typography className='text-sm sm:text-base text-neutral-600'>{title}</Typography>
      <Typography className='text-xl sm:text-2xl text-neutral-900 font-bold'>{value}</Typography>
    </Stack>
  )
}

export default ItemInfo
